module.exports = __webpack_public_path__ + "img/img_size4_test.f7ec0382.png";